/**
 * The beside-the-dataset year drop-down — client directive, 2026-09-15:
 *
 * > *"the time slider/year slider [should be] rather a drop down, this should apply to all
 * > the dataset that has a temporal aspect to it."*
 *
 * `TimeBar` (`#yearSelect`, in `IndicatorsPane`) and `EpochSlider` (`#epochSelect`, in
 * `LayersPane`'s `ActiveLayer` row) each have a temporal dataset next to a different kind of
 * "which year" state — an index into `state.years` versus a layer id keyed off a series'
 * `epochs` — so they cannot share a value type. What they *do* share is the row: the same
 * `.pane-sel-row`/`.pane-sel-ctl` markup `PaneSelect` already uses elsewhere in these two
 * panes, with a plain (ungrouped, no placeholder) option list — a year is never "nothing
 * chosen" the way an indicator or a layer can be.
 */
export interface YearOption {
  value: string;
  label: string;
}

export interface YearSelectProps {
  /** DOM id — `#yearSelect` or `#epochSelect`, the e2e/permalink-facing hook. */
  id: string;
  label: string;
  value: string;
  options: YearOption[];
  onChange: (value: string) => void;
}

export function YearSelect({ id, label, value, options, onChange }: YearSelectProps) {
  return (
    <label className="pane-sel-row" htmlFor={id}>
      <span className="pane-sel-label">{label}</span>
      <span className="pane-sel-ctl">
        <select
          id={id}
          data-paneselect={id}
          className="std pane-sel"
          aria-label={label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </span>
    </label>
  );
}

export default YearSelect;
